module.exports = __webpack_public_path__ + "img/nichephone_s_4g_black.fc640624.png";